import { toString } from '@carbon/icon-helpers';

import Undo24 from '@carbon/icons/es/undo/24';
import Redo24 from '@carbon/icons/es/redo/24';
import Cursor_124 from '@carbon/icons/es/cursor--1/24';
import Touch_124 from '@carbon/icons/es/touch--1/24';
import InformationFilled16 from '@carbon/icons/es/information/16';
import TaskStar16 from '@carbon/icons/es/task--star/16';
import TrashCan16 from '@carbon/icons/es/trash-can/16';

const strUndo24 = toString(Undo24);
const strRedo24 = toString(Redo24);
const strCursor24 = toString(Cursor_124);
const strTouch24 = toString(Touch_124);
const strInformation16 = toString(InformationFilled16);
const strTaskStar16 = toString(TaskStar16);
const strTrashCan16 = toString(TrashCan16);

export {
  strUndo24,
  strRedo24,
  strCursor24,
  strTouch24,
  strInformation16,
  strTaskStar16,
  strTrashCan16,
};
